<div class="content-block">
  <article class="article " style="margin-top:1rem">
 
     <div class="title-container">
<div style="flex:1">
    
      </div>
            <div style="flex: 10;">
        <h2 *ngIf="company != null">{{companyName}} Dashboard</h2>
      </div>
      <div style="flex:1">
    
      </div>
    </div>

    <div class="form-container" *ngIf="company_Id != undefined">
      <div class="form-column">
        <h3>Site Details</h3>
        <div style="width: 100%;">
       <app-company-mange [user]="user" [hideSaveOption]="true" [saveTrigger]="companySaveTrigger" (added)="companySave($event)"
          [selectedCompany]="company"></app-company-mange>

        </div>
      </div>
      <div class="form-column" style="border:none">
        <div class="form-column">
          <h3>View and Edit Equipment List</h3>
          <p>The equipment list can be sorted and filtered through interaction with the equipment list table.</p>
          <button class="btn btn-primary" (click)="viewEquipment()">View</button>
        </div>

        <div class="form-column topMargin">
          <h3>{{messageTitle}}</h3>
          <label  style="width:100%;margin-bottom: 0.5rem;white-space: pre-wrap;" [innerHTML]="messageBody"></label>
        </div>
      </div>

    </div>

    <div *ngIf="company_Id == undefined">
       <h3>A Error has occured while loading your user. please contact LGS</h3>
    </div>
  </article>

</div>